import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BrandMiniEntity } from '../../domain/entities/BrandMiniEntity'
import type { BrandMiniDto } from '@/backend/market'

export class BrandMiniModel extends BrandMiniEntity {
  constructor(dataDto: BrandMiniDto) {
    super()
    mapEntityProperties<BrandMiniEntity>(this, dataDto)
  }
}
 